import {
  postApiProjectsProjectIdChannelsMessaging,
  postApiProjectsProjectIdChannelsPersonal,
  postApiProjectsProjectIdGroups,
} from '@shape-construction/api/src/api';
import { useMutation } from '@tanstack/react-query';
import type { StreamChat } from 'stream-chat';

/**
 * Creates a personal channel for the current user within a project.
 *
 * @param client - The Stream Chat client instance
 * @returns A mutation for creating and watching a personal channel
 */
export const useCreatePersonalChannel = (client?: StreamChat | null) => {
  return useMutation({
    mutationFn: async (params: {
      projectId: Parameters<typeof postApiProjectsProjectIdChannelsPersonal>[0];
      requestConfig?: Parameters<typeof postApiProjectsProjectIdChannelsPersonal>[1];
    }) => {
      const channel = await postApiProjectsProjectIdChannelsPersonal(params.projectId, params.requestConfig ?? {});
      const conversation = client?.channel(channel.type, channel.id);
      await conversation?.watch();

      return conversation;
    },
  });
};

export const useCreateMessagingChannel = (client?: StreamChat | null) => {
  return useMutation({
    mutationFn: async (params: {
      projectId: Parameters<typeof postApiProjectsProjectIdChannelsMessaging>[0];
      data: Parameters<typeof postApiProjectsProjectIdChannelsMessaging>[1];
    }) => {
      const channel = await postApiProjectsProjectIdChannelsMessaging(params.projectId, params.data);
      const conversation = client?.channel(channel.type, channel.id);
      await conversation?.watch();

      return conversation;
    },
  });
};

export const useCreateGroupChannel = (client?: StreamChat | null) => {
  return useMutation({
    mutationFn: async (params: {
      projectId: Parameters<typeof postApiProjectsProjectIdGroups>[0];
      data: Parameters<typeof postApiProjectsProjectIdGroups>[1];
    }) => {
      const channel = await postApiProjectsProjectIdGroups(params.projectId, params.data);
      const conversation = client?.channel(channel.channel.type, channel.channel.id);
      await conversation?.watch();

      return conversation;
    },
  });
};
